import React, { useState, useContext } from 'react'
import { CategoriesContext, LawyerContext } from '../../../../partials/Context';
import getCookie from '../../../../partials/cookie';
import { Errors } from '../../../../partials/Partials';

function AddCaseForm({getCurrentLawyer}) {
    const categories = useContext(CategoriesContext);
    const lawyer = useContext(LawyerContext);
    const {id} = lawyer || ''
    const [errors, setErrors] = useState([])
    
    const {prywatne, firmowe} = categories || [];
    let prywatne_list = [];
    let firmowe_list = [];

    if(prywatne) {
    prywatne.map(item => {
        prywatne_list.push(
            <option key={item.id} value={item.id}>{item.name}</option>
        )
        return prywatne_list
    })
    }   

    if(firmowe) {
    firmowe.map(item => {
        firmowe_list.push(
             <option key={item.id} value={item.id}>{item.name}</option>
        )
        return firmowe_list
    })
    }

    const submitCase = (e) => {
        e.preventDefault()
        const csrftoken = getCookie('csrftoken');
        const payload = {
            description: e.target.querySelector('#description').value,
            category: e.target.querySelector('#category').value,
            tags: e.target.querySelector('#case_tags').value,
            lawyer: id,
        }

        fetch('/api/lawyer_profiles_extended/current/add_case/', {
            method:'POST',
            headers: {
                'Content-Type': 'application/json',
                "X-CSRFToken": csrftoken
            },
            body: JSON.stringify({
                ...payload
            })
        }).then(res => {
            if (res.ok) {
                e.target.querySelector('#description').value = ''
                e.target.querySelector('#category').value = null
                e.target.querySelector('#case_tags').value = ''
                setErrors([])
                getCurrentLawyer()
            } else {
                setErrors(['Nie udało się dodać sprawy'])
            }
        })
    }

    return (
    <form onSubmit={(e) => submitCase(e)} id="add-case-form">
        <Errors errors={errors} />
        <div className="form-group">
            <label className="col-sm-3 control-label">Opis sprawy: </label>
            <div className="input-field">
                <textarea id="description" placeholder="Wpisz np.: wygrana sprawa o zasądzenie zaległego wynagrodzenia i premii pracownika działu sprzedaży firmy farmaceutycznej" maxLength="2048" required="required" text-area-autosize="" />
                <div className="help-block">
                    Krótki opis sprawy w jednym lub dwóch zdaniach.
                    Nie umieszczaj ogólników, lecz konkretny przykład sprawy.
                    Klienci szukają tu opisów spraw podobnych do swojej.
                </div>
            </div>
        </div>
        <div className="form-group">
            <label className="col-sm-3 control-label">Kategoria: </label>
            <div className="input-field">
                <select required="required" id="category">
                    <option style={{color: '#ccc'}} value="null">wybierz kategorię problemu prawnego</option>
                    <optgroup label="Prywatna">
                        {prywatne_list}
                    </optgroup>
                    <optgroup label="Firmowa">
                        {firmowe_list}
                    </optgroup>
                </select>
            </div>
        </div>
        <div className="form-group">
            <label className="col-sm-3 control-label" htmlFor="case_tags">
                Słowa kluczowe:
                <div className="help-block">oddzielone przecinkiem<br/>opcjonalne</div>
            </label>
            <div className="input-field">
                <input id="case_tags" type="text" maxLength="100" placeholder="np. pozew, spółki akcyjne, przygotowanie umów"/>
            </div>
        </div>
        <button className="btn btn-primary" type="submit">Dodaj</button>
        <hr />
        
    </form>
    )
}

export default AddCaseForm